// The three music-genre groups the filters offer. Which genre belongs where is
// decided by the API (backend/utils/musicGroups.js - "popular" is every genre
// that is not classical or folk), which sends the groups with their counts and
// member genres in /events/filters/options. This file only adds the icon.
// Shared verbatim with mobile/utils/musicGroups.js.

const ICONS = {
  popular: '♫',
  classical: '♩',
  folk: '♬'
};

export function musicGroupIcon(id) {
  return ICONS[id] || '♪';
}

// Only groups with upcoming events are offered, like the category chips.
export function buildMusicGroupOptions(musicGroups = []) {
  return musicGroups.filter((group) => group.count > 0);
}
